<template>
  <el-dialog v-model="show" :show-close="false" title="选择链接">
    <el-tabs v-model="className" :tab-position="tabPosition" @tab-click="handleBigTabClick">
      <el-tab-pane label="机构链接" name="content">
        <!-- tab切换 -->
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleTabClick">
          <el-tab-pane label="商务应用功能" name="miniPath">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryMiniPath" @submit.prevent>
                  <el-form-item label="类型">
                    <el-select v-model="queryMiniPath.type" @change="selectMinipath">
                      <el-option v-for="item in minipathType" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item>
                    <el-button :icon="Search" type="primary" @click="selectMinipath">
                      查询
                    </el-button>
                  </el-form-item> -->
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>
            <el-table ref="miniPathTable" border :data="miniPathData" :row-key="getRowKeys"
              @select="handleSelectionChangeByMiniPath">
              <el-table-column type="selection" width="55" />
              <el-table-column align="center" label="页面名称" prop="name" show-overflow-tooltip />
              <!-- <el-table-column align="center" label="页面路径" prop="router" show-overflow-tooltip /> -->

              <el-table-column align="center" label="页面路径" prop="router" show-overflow-tooltip>
                <template #default="{ row }">
                  <span v-if="row.router == 'subPackage/exhibition/customer-exhibition/apply-form'">
                    <el-select v-model="checkIdentity">
                      <el-option v-for="item in identityList" :key="item.identityType" :label="item.name"
                        :value="item.identityType" />
                    </el-select>
                  </span>

                  <span v-else-if="row.id == 13">
                    <el-select v-model="exhibitionListRouter">
                      <el-option v-for="item in exhibitionListRouterList" :key="item.id" :label="item.name"
                        :value="item.id" />
                    </el-select>
                  </span>

                  <span v-else-if="row.id == 36">
                    <el-select v-model="recruitmentBrandGroupId">
                      <el-option v-for="item in recruitmentGroupList" :key="item.id" :label="item.name"
                        :value="item.id" />
                    </el-select>
                  </span>

                  <span v-else-if="row.id == 37">
                    <el-select v-model="recruitmentJobGroupId">
                      <el-option v-for="item in recruitmentGroupList" :key="item.id" :label="item.name"
                        :value="item.id" />
                    </el-select>
                  </span>

                  <span v-else>{{ row.router }}</span>
                </template>
              </el-table-column>
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="机构页面" name="page">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryForm2" @submit.prevent>
                  <el-form-item label="页面标题">
                    <el-input v-model.trim="queryForm2.name" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryPlatePageData">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>

            <el-table ref="pageTable" v-loading="listLoading2" border :data="pageList" :row-key="getRowKeys"
              @select="handleSelectionChangeByPage">
              <el-table-column type="selection" width="55" />

              <el-table-column align="center" label="页面标题" prop="name" show-overflow-tooltip />
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <el-pagination background :current-page="queryForm2.pageNumber" :layout="layout"
              :page-size="queryForm2.pageSize" :total="total3" @current-change="handleCurrentChangePage"
              @size-change="handleSizeChangePage" />
          </el-tab-pane>

          <el-tab-pane v-if="meetingCode" label="应用内页面" name="exhPage">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryFormExhPage" @submit.prevent>
                  <el-form-item label="页面标题">
                    <el-input v-model.trim="queryFormExhPage.name" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryExhPageData">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>

            <el-table ref="exhPageTable" v-loading="listLoadingExhPage" border :data="exhPageList" :row-key="getRowKeys"
              @select="handleSelectionChangeByExhPage">
              <el-table-column type="selection" width="55" />

              <el-table-column align="center" label="页面标题" prop="name" show-overflow-tooltip />
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <el-pagination background :current-page="queryFormExhPage.pageNumber" :layout="layout"
              :page-size="queryFormExhPage.pageSize" :total="exhPageTotal" @current-change="handleCurrentChangeExhPage"
              @size-change="handleSizeChangeExhPage" />
          </el-tab-pane>
          <el-tab-pane label="展会页面" name="exhibition">
            <el-table ref="exhTable" v-loading="listLoading4" border :data="exhList" :row-key="getRowKeys"
              @select="handleSelectionChangeByExhibition">
              <el-table-column type="selection" width="55" />
              <el-table-column fixed label="展会名称" prop="meetingName" show-overflow-tooltip />

              <el-table-column fixed label="展会时间" prop="listTime" show-overflow-tooltip />
              <el-table-column fixed label="展会备注" prop="exRemark" show-overflow-tooltip />

              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <!-- <el-pagination background :current-page="queryForm3.pageNum" :layout="layout" :page-size="queryForm3.pageSize" :total="total2" @current-change="handleCurrentChangeArticle" @size-change="handleSizeChangeArticle" /> -->
          </el-tab-pane>
          <el-tab-pane label="会议页面" name="holdMeet">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryFormByHoldMeet" @submit.prevent>
                  <el-form-item label="会议名称">
                    <el-input v-model.trim="queryFormByHoldMeet.likeName" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryHoldMeet">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>
            <el-table ref="holdMeetTable" v-loading="listLoading5" border :data="holdMeetList" :height="500"
              :row-key="getRowKeys" @select="handleSelectionChangeByHoldMeet">
              <el-table-column type="selection" width="55" />
              <el-table-column fixed label="会议名称" prop="name" show-overflow-tooltip />
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="内容页面" name="Article">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryForm3" @submit.prevent>
                  <el-form-item label="内容标题">
                    <el-input v-model.trim="queryForm3.title" clearable placeholder="请输入内容标题"
                      @keyup.enter="queryArticleData" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryArticleData">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>

            <el-table ref="articleTable" v-loading="listLoading3" border :data="articleList" :row-key="getRowKeys"
              @select="handleSelectionChangeByArticle">
              <el-table-column type="selection" width="55" />
              <el-table-column fixed label="内容标题" prop="title" show-overflow-tooltip />

              <el-table-column fixed label="内容类型" prop="articleCategoryName" show-overflow-tooltip />

              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <el-pagination background :current-page="queryForm3.pageNum" :layout="layout"
              :page-size="queryForm3.pageSize" :total="total2" @current-change="handleCurrentChangeArticle"
              @size-change="handleSizeChangeArticle" />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="平台链接" name="plantForm">
        <!-- tab切换 -->
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleTabClick">
          <el-tab-pane label="关联机构" name="enterprise">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryFormByEnterprise" @submit.prevent>
                  <el-form-item label="机构名称">
                    <el-input v-model.trim="queryFormByEnterprise.likeName" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryEnterprise">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>
            <el-table ref="enterpriseTable" v-loading="listLoading6" border :data="enterpriseList" :height="500"
              :row-key="getRowKeys" @select="handleSelectionChangeByEnterprise">
              <el-table-column type="selection" width="55" />
              <el-table-column fixed label="机构名称" prop="name" show-overflow-tooltip />
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="店铺" name="shop">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryForm" @submit.prevent>
                  <el-form-item label="店铺名称">
                    <el-input v-model.trim="queryForm.shopName" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryShopData">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>
            <el-table ref="shopTable" v-loading="listLoading" border :data="list" :row-key="getRowKeys"
              style="width: 100%" @select="handleSelectionChangeByShop">
              <el-table-column type="selection" width="55" />
              <el-table-column label="店铺名称" prop="shopName" show-overflow-tooltip />
              <el-table-column label="联系电话1" prop="shopContactNumber" show-overflow-tooltip />
              <el-table-column label="联系地址" prop="shopContactNumber" show-overflow-tooltip>
                <template #default="{ row }">
                  {{ row.shopProvince }} - {{ row.shopCity }} - {{ row.shopArea }} -
                  {{ row.shopAddress }}
                </template>
              </el-table-column>
              <el-table-column label="营业时间" prop="shopBusinessTime" show-overflow-tooltip />

              <el-table-column label="状态" prop="status" show-overflow-tooltip>
                <template #default="{ row }">
                  <el-switch v-model="row.status" active-text="上线" disabled inactive-text="下线" size="large"
                    @change="shopStatusChange(row.id, row.status)" />
                </template>
              </el-table-column>
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <el-pagination background :current-page="queryForm.pageNumber" :layout="layout"
              :page-size="queryForm.pageSize" :total="total" @current-change="handleCurrentChangeShop"
              @size-change="handleSizeChangeShop" />
          </el-tab-pane>
          <el-tab-pane label="活动" name="active">
            <vab-query-form>
              <vab-query-form-left-panel :span="12">
                <el-form :inline="true" :model="queryForm1" @submit.prevent>
                  <el-form-item label="活动名称">
                    <el-input v-model.trim="queryForm1.title" clearable placeholder="请输入名称" />
                  </el-form-item>
                  <el-form-item>
                    <el-button :icon="Search" type="primary" @click="queryActiveData">查询</el-button>
                  </el-form-item>
                </el-form>
              </vab-query-form-left-panel>
            </vab-query-form>

            <el-table ref="acitveTable" v-loading="listLoading1" border :data="activeList" :row-key="getRowKeys"
              @select="handleSelectionChangeByActive">
              <el-table-column type="selection" width="55" />

              <el-table-column fixed label="活动标题" prop="title" show-overflow-tooltip />
              <el-table-column fixed label="开始时间" show-overflow-tooltip>
                <template #default="{ row }">
                  <span>{{ handleDate(row.startTime) }}</span>
                </template>
              </el-table-column>

              <el-table-column fixed label="结束时间" show-overflow-tooltip>
                <template #default="{ row }">
                  <span>{{ handleDate(row.endTime) }}</span>
                </template>
              </el-table-column>

              <el-table-column label="活动地址" prop="address" show-overflow-tooltip />
              <el-table-column label="主办方" prop="organisers" show-overflow-tooltip />
              <el-table-column label="活动人数" prop="peopleNum" show-overflow-tooltip />
              <el-table-column label="活动亮点" prop="sparkle" show-overflow-tooltip />
              <template #empty>
                <el-empty class="vab-data-empty" description="暂无数据" />
              </template>
            </el-table>
            <el-pagination background :current-page="queryForm1.pageNum" :layout="layout"
              :page-size="queryForm1.pageSize" :total="total1" @current-change="handleCurrentChangeActive"
              @size-change="handleSizeChangeActive" />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="第三方链接" name="thirdLink">
        <!-- tab切换 -->
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleTabClick">
          <el-tab-pane v-if="!multFlag" label="外部链接" name="link">
            <el-form>
              <el-form-item label="H5链接地址">
                <el-input v-model="urlLink" placeholder="请输入需要跳转的h5链接" />
                <div style="font-size: 14px; color: red">* 链接地址需要配置在小程序白名单内，请确认后输入</div>
              </el-form-item>

              <el-form-item label="是否需要注册">
                <el-radio-group v-model="needToken">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane v-if="!multFlag" label="小程序" name="mini">
            <el-form>
              <el-form-item label="小程序名称">
                <el-input v-model="miniData.name" placeholder="请输入小程序名称" />
              </el-form-item>

              <el-form-item label="小程序appId">
                <el-input v-model="miniData.appId" placeholder="请输入小程序appId" />
              </el-form-item>
              <el-form-item label="路径地址">
                <el-input v-model="miniData.path" placeholder="请输入路径地址" />
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane v-if="!multFlag" label="视频号" name="wxVideo">
            <el-form>
              <el-form-item label="跳转类型">
                <el-radio-group v-model="wxVideoType.type" class="ml-4">
                  <el-radio label="homePage" size="large">视频号首页</el-radio>
                  <el-radio label="detail" size="large">视频详情页</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="视频号Id">
                <el-input v-model="wxVideoType.finderUserName" placeholder="请输入需要跳转的视频号 id，以“sph”开头的id，可在视频号助手获取" />
              </el-form-item>
              <el-form-item v-if="wxVideoType.type == 'detail'" label="视频Id">
                <el-input v-model="wxVideoType.eventId" placeholder="请输入需要跳转的视频活动 id，可在视频号助手获取" />
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane v-if="!multFlag" label="公众号" name="officialAccount">
            <el-form>
              <el-form-item label="跳转类型">
                <el-radio-group v-model="officialAccountData.targetType">
                  <el-radio label="profile">公众号主页</el-radio>
                  <el-radio label="article">公众号文章</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="officialAccountData.targetType == 'article'" label="文章链接">
                <el-input v-model.trim="officialAccountData.articleUrl" placeholder="请输入公众号文章链接" />
                <div style="font-size: 14px; color: red">* 临时链接或异常状态的文章无法打开</div>
              </el-form-item>

              <el-form-item v-else label="公众号原始ID">
                <el-input v-model.trim="officialAccountData.originId" placeholder="请输入公众号原始ID，如 gh_xxxxxxxx" />
                <div style="font-size: 14px; color: red">
                  * 公众号须与小程序主体相同或已建立关联
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="暂不跳转" name="notopen">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleTabClick">
          <el-tab-pane label="暂不跳转" name="notopen">
            <el-form>
              <el-form-item label="暂不跳转">
                <el-switch v-model="notOpenFlag" />
              </el-form-item>

              <el-form-item label="提示文案">
                <el-input v-model="notOpenMes" placeholder="请输入提示文案" />
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, getCurrentInstance, reactive, toRefs, nextTick, watch } from 'vue'
import { getShopList } from '@/api/shop'
import { activeList } from '@/api/active'
import { getPage } from '@/api/page'
import { getArticleList } from '@/api/content'
import { exShelfAndUnshelfList } from '@/api/exhibitionManage'
import { Search } from '@element-plus/icons'
import { parseTime } from '@/utils/index'
import { getPlateAllData } from '@/api/workBench'
import { getAllEnterpriseListByName, enterpriseGroupQueryList } from '@/api/enterPriseApi'
import { useRoute } from 'vue-router'
import { getIdentity } from '@/api/channel'
import { queryRecruitmentBrandGroup } from '@/api/recruitment/brand'
import { _baseH5URL } from '@/config'

export default defineComponent({
  name: 'chooseLink.vue',
  props: {
    multChoose: {
      type: Boolean,
      default: false,
    },
    enterPriseCode: {
      default: '',
      type: String,
    },
    linkEnterpriseCode: {
      default: '',
      type: String,
    },
  },
  emits: ['chooseLink'],
  setup(props, { emit }) {
    let customInfo = localStorage.getItem('customInfo')
    if (customInfo) customInfo = JSON.parse(customInfo)
    const { proxy } = getCurrentInstance()
    // console.log('proxy', proxy)
    const route = useRoute()
    const isEnterpriseItem = JSON.parse(localStorage.isEnterpriseItem || '{}')
    const cloneData = (data) => JSON.parse(JSON.stringify(data))
    const getDefaultDialogState = (meetingCode = route.query.meetingCode || undefined, miniPathList = []) => ({
      exhibitionListRouter: '',
      recruitmentBrandGroupId: '',
      recruitmentJobGroupId: '',
      activeName: 'miniPath',
      className: 'content',
      queryForm: { shopName: '', pageNumber: 1, pageSize: 10 },
      queryForm1: { title: '', pageNum: 1, pageSize: 10 },
      queryForm2: { name: '', pageNumber: 1, pageSize: 10 },
      queryFormExhPage: {
        name: '',
        pageNumber: 1,
        pageSize: 10,
        meetingCode,
      },
      enterPriseListParams: {
        pageNum: 1,
        pageSize: 999999,
        meetingCode,
      },
      queryForm3: { pageNum: 1, pageSize: 10, status: 'PUBLISH', title: '' },
      queryFormByHoldMeet: { meetingType: 'HOLD_MEETING', likeName: '' },
      queryFormByEnterprise: { meetingType: 'HOLD_MEETING', likeName: '' },
      queryMiniPath: { type: '' },
      chooseVal: [],
      echoList: [],
      alreadyChoose: [],
      urlLink: '',
      needToken: false,
      miniData: {
        appId: '',
        path: '',
        name: '',
      },
      wxVideoType: {
        finderUserName: '',
        eventId: '',
        type: 'homePage',
      },
      officialAccountData: {
        targetType: 'profile',
        articleUrl: '',
        originId: '',
      },
      meetingCode,
      notOpenMes: '敬请期待',
      notOpenFlag: false,
      checkIdentity: '',
      miniPathData: cloneData(miniPathList),
    })
    const state = reactive({
      isEnterpriseItem,
      exhibitionListRouterList: [
        {
          name: '默认机构列表',
          id: '',
        },
      ],
      // 招聘机构组列表
      recruitmentGroupList: [],
      // 招聘机构组列表映射
      recruitmentGroupListMap: {},
      ...getDefaultDialogState(),
      tabPosition: 'left',
      queryForm4: {
        isShelf: '',
        meetingName: '',
        pageNum: 1,
        pageSize: 9999,
        status: '',
      },
      total: 0,
      total1: 0,
      total2: 0,
      total3: 0,
      exhPageTotal: 0,
      listLoading: false,
      listLoading1: false,
      listLoading2: false,
      listLoading3: false,
      listLoading4: false,
      listLoading5: false,
      listLoading6: false,
      list: [],
      activeList: [],
      articleList: [],
      minipathType: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 'exh',
          label: '应用功能',
        },
        {
          value: 'enterprise',
          label: '机构功能',
        },
        {
          value: 'other',
          label: '其他功能',
        },
      ],
      miniPathList: [
        {
          id: 4,
          name: '用户注册',
          router: 'subPackage/exhibition/customer-exhibition/apply-form',
          type: 'miniPath',
          extraParams: {},
          pathType: 'exh',
        },
        // {
        //   id: 4,
        //   name: '会员注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'MEMBER',
        //   },
        //   pathType: 'exh',
        // },
        // {
        //   id: 5,
        //   name: '媒体注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'MEDIA',
        //   },
        //   pathType: 'exh',
        // },
        // {
        //   id: 6,
        //   name: '工作人员注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'STF',
        //   },
        //   pathType: 'exh',
        // },
        // {
        //   id: 7,
        //   name: '嘉宾注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'GUEST',
        //   },
        //   pathType: 'exh',
        // },
        // {
        //   id: 8,
        //   name: '机构注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'EXHIBITOR',
        //   },
        //   pathType: 'exh',
        // },
        // {
        //   id: 9,
        //   name: '活动合作方注册',
        //   router: 'subPackage/exhibition/customer-exhibition/apply-form',
        //   type: 'miniPath',
        //   extraParams: {
        //     identity: 'ACTIVE',
        //   },
        //   pathType: 'exh',
        // },
        {
          id: 10,
          name: '应用动态',
          router: 'subPackage/social/pages/user-trends/meet-dynamic',
          type: 'miniPath',
          pathType: 'exh',
        },
        ...(customInfo.tenantKey === 'GDC'
          ? [
            {
              id: 38,
              name: '定制展会动态',
              router: 'subPackage/social/pages/user-trends/custom-meet-dynamic',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 39,
              name: '定制机构动态',
              router: 'subPackage/shops/pages/custom-made-enterprise-dynamic/index',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 40,
              name: '定制供需广场',
              router: 'subPackage/account/supplyDemand/filter?isCustomId=yes',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 41,
              name: '定制论坛-培训',
              router: 'subPackage/shops/pages/date-time/date-time-inside?tagIndex=0',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 42,
              name: '定制论坛-活动',
              router: 'subPackage/shops/pages/date-time/date-time-inside?tagIndex=1',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 43,
              name: '定制-找政策',
              router: 'subPackage/social/pages/user-trends/meet-official-dynamic',
              type: 'miniPath',
              pathType: 'exh',
            },
            {
              id: 44,
              name: '定制-找技术',
              router: 'subPackage/social/pages/user-trends/meet-dynamic-out',
              type: 'miniPath',
              pathType: 'exh',
            },
          ]
          : []),
        // WeMeet荟神专享菜单 娟姐定制
        ...(isEnterpriseItem.enterpriseCode === 'EN1728995464352718848' ? [{
          id: 45,
          name: '应用智能体',
          router: `subPackage/index/webview/webview?url=${encodeURIComponent(`${_baseH5URL}/aigc`)}`,
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 46,
          name: '快速充值',
          router: 'subPackage/account/aiTranslate/accountBalance',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 47,
          name: 'AI办会',
          router: `subPackage/index/webview/webview?url=${encodeURIComponent(`${_baseH5URL}/aigc?appKey=WX_MINI_WEMEET&sourceId=&sourceType=USER&language=CN&showFile=yes&enterpriseCode=&needToken=Y`)}`,
          type: 'miniPath',
          pathType: 'exh',
        }] : []),
        {
          id: 11,
          name: '门票购买',
          router: 'subPackage/admission-ticket/buy/exhibition-ticket',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 12,
          name: '大会议程',
          router: 'subPackage/account/date-time/date-time-inside',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 13,
          name: '机构列表',
          router: 'subPackage/customPage/exhibitor/exhibitorList',
          type: 'miniPath',
          extraParams: {},
          pathType: 'exh',
        },
        {
          id: 14,
          name: '参会列表',
          router: 'subPackage/meet/holdMeet/all-attend',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 15,
          name: '商机配对',
          router: 'subPackage/customPage/exhibition/business/filter-index/index ',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 16,
          name: '应用产品列表',
          router: 'subPackage/customPage/exhibitor/exhibitsList',
          type: 'miniPath',
          pathType: 'exh',
        },

        {
          id: 17,
          name: '应用产品列表-展会',
          router: 'subPackage/customPage/exhibitor/exhibitsList?type=EXHIBITION',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 18,
          name: '应用产品列表-场馆',
          router: 'subPackage/customPage/exhibitor/exhibitsList?type=VENUES',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 19,
          name: '应用产品列表-招聘',
          router: 'subPackage/customPage/exhibitor/exhibitsList?type=WORK',
          type: 'miniPath',
          pathType: 'exh',
        },

        {
          id: 20,
          name: '活动列表',
          // router: 'pages/index-activity/index-activity',
          router: 'subPackage/shops/pages/index-activity/index',
          type: 'miniPath',
          pathType: 'other',
        },
        {
          id: 21,
          name: '店铺列表',
          // router: 'pages/index-shop/index-shop',
          router: 'subPackage/shops/pages/index-shop/index',
          type: 'miniPath',
          pathType: 'other',
        },
        {
          id: 22,
          name: '展会列表',
          router: 'subPackage/index/index-page-list/index-page-list',
          type: 'miniPath',
          pathType: 'other',
        },

        {
          id: 23,
          name: '论坛列表',
          router: 'subPackage/exhibition/customer-exhibition/forum-list',
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 24,
          name: '合作伙伴申请',
          router:
            'subPackage/exhibition/customer-exhibition/apply-form?navTitle=活动合作方注册&identity=ACTIVE&meetingCode=EX1846741634604150784',
          type: 'miniPath',
          extraParams: {
            identity: 'ACTIVE',
            type: 'H5',
          },
          pathType: 'exh',
        },
        // {
        //   id: 7,
        //   name: '展商列表H5',
        //   router: 'subPackage/index/webview/webview-h5 ',
        //   type: 'miniPath',
        //   extraParams: {
        //     type: 'H5',
        //     webviewUrl: '/exhibitor/exhibitorList',
        //   },
        //   pathType: 'other',
        // },
        // {
        //   id: 11,
        //   name: '展品列表H5',
        //   router: 'subPackage/index/webview/webview-h5',
        //   type: 'miniPath',
        //   extraParams: {
        //     type: 'H5',
        //     webviewUrl: '/exhibitor/exhibitsList',
        //   },
        //   pathType: 'other',
        // },

        {
          id: 25,
          name: '机构活动',
          router: `subPackage/enterprise/pages/exhibition-plan/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 26,
          name: '机构动态',
          router: `subPackage/social/pages/enterprise-trends/index?navTitle=机构动态`,
          type: 'miniPath',
          pathType: 'enterprise',
        },

        {
          id: 27,
          name: '机构入驻',
          router: 'subPackage/enterprise/pages/enterprise-enter-welcome/index',
          type: 'miniPath',
          pathType: 'other',
        },
        {
          id: 28,
          name: '机构产品列表',
          router: `subPackage/enterprise/pages/product-list/all`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 29,
          name: '团队介绍',
          router: `subPackage/customPage/enterprise/group/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 30,
          name: '机构介绍',
          router: `subPackage/account/enterprise/enterpriseIntro/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 31,
          name: '机构视频',
          router: `subPackage/account/enterprise/enterpriseVideo/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 32,
          name: '机构资讯',
          router: `subPackage/account/enterprise/enterpriseInfo/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 33,
          name: '联系我们',
          router: `subPackage/account/enterprise/linkUs/index`,
          type: 'miniPath',
          pathType: 'enterprise',
        },
        {
          id: 34,
          name: '发布供需',
          router: `subPackage/account/supplyDemand/guide?meetingCode=${route.query.meetingCode}`,
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 35,
          name: '供需广场',
          router: `subPackage/account/supplyDemand/filter?meetingCode=${route.query.meetingCode}`,
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 36,
          name: '招聘机构列表',
          router: `subPackage/shops/pages/jobs/enterpriseList/index?meetingCode=${route.query.meetingCode}`,
          type: 'miniPath',
          pathType: 'exh',
        },
        {
          id: 37,
          name: '岗位列表',
          router: `subPackage/shops/pages/jobs/jobList/index?meetingCode=${route.query.meetingCode}`,
          type: 'miniPath',
          pathType: 'exh',
        },
      ],
      exhList: [],
      exhPageList: [],
      holdMeetList: [],
      enterpriseList: [],
      layout: 'prev, pager, next',
      show: false,
      acitveTable: null,
      shopTable: null,
      pageTable: null,
      exhTable: null,
      holdMeetTable: null,
      articleTable: null,
      miniPathTable: null,
      exhPageTable: null,
      enterpriseTable: null,
      multFlag: false,

      pageList: [],
      identityList: [],
    })

    // tab切换,回显默认数据
    const handleTabClick = (tab) => {
      // state.chooseVal = []
      state.echoList = []
      // resetRowSelection()
      console.log(tab.props.name)
      tabChangeChoose(state.alreadyChoose, tab.props.name)
    }

    watch(
      () => props.multChoose,
      (count) => {
        state.multFlag = count
      }
    )

    const syncMeetingContext = (meetingCode) => {
      const currentMeetingCode = meetingCode || route.query.meetingCode || undefined
      state.meetingCode = currentMeetingCode
      state.queryFormExhPage.meetingCode = currentMeetingCode
      state.enterPriseListParams.meetingCode = currentMeetingCode
      state.miniPathList.forEach((item) => {
        const routerMap = {
          34: `subPackage/account/supplyDemand/guide?meetingCode=${currentMeetingCode || ''}`,
          35: `subPackage/account/supplyDemand/filter?meetingCode=${currentMeetingCode || ''}`,
          36: `subPackage/shops/pages/jobs/enterpriseList/index?meetingCode=${currentMeetingCode || ''}`,
          37: `subPackage/shops/pages/jobs/jobList/index?meetingCode=${currentMeetingCode || ''}`,
        }
        if (routerMap[item.id]) item.router = routerMap[item.id]
      })
    }

    const resetDialogState = () => {
      Object.entries(getDefaultDialogState(state.meetingCode, state.miniPathList)).forEach(([key, value]) => {
        state[key] = value
      })
    }

    const showDialog = async (val = [], meetingCode) => {
      const chooseList = Array.isArray(val) ? val : []
      console.log(chooseList, '======>>>>')
      syncMeetingContext(meetingCode)
      resetDialogState()
      resetRowSelection()
      state.chooseVal = JSON.parse(JSON.stringify(chooseList))
      state.alreadyChoose = JSON.parse(JSON.stringify(chooseList))
      state.show = true
      console.log(props.multChoose)
      const { data } = await getIdentity()
      console.log(data)
      state.identityList = data

      console.log(state.meetingCode)
      if (state.meetingCode) {
        const { data: exhibitionListRouterList } = await enterpriseGroupQueryList(state.enterPriseListParams)
        state.exhibitionListRouterList = [{ name: '默认机构列表', id: '' }, ...exhibitionListRouterList.list]
        const { data: recruitmentGroupList } = await queryRecruitmentBrandGroup({
          meetingCode: state.meetingCode,
        })
        state.recruitmentGroupList = recruitmentGroupList
        state.recruitmentGroupListMap = Object.fromEntries(recruitmentGroupList.map(({ id, name }) => [id, name]))
      }

      // 判断是否选择过，选择回显
      console.log(chooseList, 'asdasd')
      if (chooseList.length > 0) {
        showHasChoose(chooseList)
      } else {
        resetRowSelection()
      }
      await getexhPageData()
    }

    // 清空多选数据源
    const resetRowSelection = () => {
      nextTick(() => {
        const selectionMap = [
          ['activeList', 'acitveTable'],
          ['list', 'shopTable'],
          ['pageList', 'pageTable'],
          ['exhPageList', 'exhPageTable'],
          ['articleList', 'articleTable'],
          ['miniPathList', 'miniPathTable'],
          ['exhList', 'exhTable'],
          ['holdMeetList', 'holdMeetTable'],
          ['enterpriseList', 'enterpriseTable'],
        ]

        selectionMap.forEach(([listKey, tableKey]) => {
          state[listKey]?.forEach((item) => {
            state[tableKey] && state[tableKey].toggleRowSelection(item, false)
          })
        })
      })
    }

    const closeDialog = () => {
      state.show = false
      resetRowSelection()
      resetDialogState()
    }

    const setOfficialAccountEcho = (link = {}) => {
      state.activeName = 'officialAccount'
      state.className = 'thirdLink'
      if (link.type == 'officialAccountProfile') {
        state.officialAccountData.targetType = 'profile'
        state.officialAccountData.originId = link.url || ''
      } else {
        state.officialAccountData.targetType = 'article'
        state.officialAccountData.articleUrl = link.url || ''
      }
    }

    /**
     * 展示回显数据
     * */
    const showHasChoose = (val) => {
      state.echoList = val.map((item) => (item.type == val[0].type ? item.id || item.code : ''))
      // 根据类型判断，单选多选只有一种类型，根据type 字段判断
      if (val[0].type == 'active') {
        state.activeName = 'active'
        state.className = 'plantForm'
        nextTick(() => {
          state.activeList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.acitveTable.toggleRowSelection(item, true)
            } else {
              state.acitveTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'shop') {
        state.activeName = 'shop'
        state.className = 'plantForm'
        nextTick(() => {
          state.list.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.shopTable.toggleRowSelection(item, true)
            } else {
              state.shopTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'Article') {
        state.activeName = 'Article'
        state.className = 'content'
        nextTick(() => {
          state.articleList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.articleTable.toggleRowSelection(item, true)
            } else {
              state.articleTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'exhibition') {
        state.activeName = 'exhibition'
        state.className = 'content'
        nextTick(() => {
          state.exhList.forEach((item) => {
            if (state.echoList.includes(item.code)) {
              state.exhTable.toggleRowSelection(item, true)
            } else {
              state.exhTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'holdMeet') {
        state.activeName = 'holdMeet'
        state.className = 'content'
        nextTick(() => {
          state.holdMeetList.forEach((item) => {
            if (state.echoList.includes(item.code)) {
              state.holdMeetTable.toggleRowSelection(item, true)
            } else {
              state.holdMeetTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'page') {
        state.activeName = 'page'
        state.className = 'content'
        nextTick(() => {
          state.pageList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.pageTable.toggleRowSelection(item, true)
            } else {
              state.pageTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'exhPage') {
        state.activeName = 'exhPage'
        state.className = 'content'
        nextTick(() => {
          state.exhPageList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.exhPageTable.toggleRowSelection(item, true)
            } else {
              state.exhPageTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (val[0].type == 'miniPath') {
        state.activeName = 'miniPath'
        state.className = 'content'
        nextTick(() => {
          state.miniPathData.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.miniPathTable.toggleRowSelection(item, true)
            } else {
              state.miniPathTable.toggleRowSelection(item, false)
            }
          })
        })
        val.forEach((item) => {
          console.log(item, '===vvvvvvvv')
          if (item.extraParams && item.extraParams.identity) {
            state.checkIdentity = item.extraParams.identity
          }

          const groupId = item.extraParams?.groupId

          if (groupId) {
            if (item.id == 13) {
              state.exhibitionListRouter = groupId
            } else if (item.id == 36) {
              state.recruitmentBrandGroupId = groupId
            } else if (item.id == 37) {
              state.recruitmentJobGroupId = groupId
            }
          }
        })
      }
      if (val[0].type == 'link') {
        console.log(val[0], `/v/v/v/v/v/`)
        state.activeName = 'link'
        state.className = 'thirdLink'
        state.urlLink = val[0].url
        state.needToken = val[0].extraParams.needToken
      }
      if (val[0].type == 'mini') {
        state.activeName = 'mini'
        state.className = 'thirdLink'
        state.miniData = val[0].miniData
      }
      if (val[0].type == 'wxVideo') {
        state.activeName = 'wxVideo'
        state.className = 'thirdLink'
        state.wxVideoType = val[0].wxVideoType
      }
      if (['officialAccount', 'officialAccountProfile'].includes(val[0].type)) {
        setOfficialAccountEcho(val[0])
      }
      if (val[0].type == 'notopen') {
        state.activeName = 'notopen'
        state.className = 'notopen'
        state.notOpenMes = val[0].extraParams.notOpenMes
        state.notOpenFlag = val[0].extraParams.notOpenFlag
      }
    }

    /**
     *   tab 切换数据回显
     * */
    const tabChangeChoose = (val, type) => {
      state.echoList = val.map((item) => (item.type == type ? item.id || item.code : ''))
      console.log(state.echoList)
      // 根据类型判断，单选多选只有一种类型，根据type 字段判断
      if (type == 'active') {
        state.activeName = 'active'
        nextTick(() => {
          state.activeList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.acitveTable.toggleRowSelection(item, true)
            } else {
              state.acitveTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'shop') {
        state.activeName = 'shop'
        nextTick(() => {
          state.list.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.shopTable.toggleRowSelection(item, true)
            } else {
              state.shopTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'exhibition') {
        state.activeName = 'exhibition'
        nextTick(() => {
          state.exhList.forEach((item) => {
            if (state.echoList.includes(item.code)) {
              state.exhTable.toggleRowSelection(item, true)
            } else {
              state.exhTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'holdMeet') {
        state.activeName = 'holdMeet'
        nextTick(() => {
          state.holdMeetList.forEach((item) => {
            if (state.echoList.includes(item.code)) {
              state.holdMeetTable.toggleRowSelection(item, true)
            } else {
              state.holdMeetTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'Article') {
        state.activeName = 'Article'
        nextTick(() => {
          state.articleList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.articleTable.toggleRowSelection(item, true)
            } else {
              state.articleTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'page') {
        state.activeName = 'page'
        nextTick(() => {
          state.pageList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.pageTable.toggleRowSelection(item, true)
            } else {
              state.pageTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'exhPage') {
        state.activeName = 'exhPage'
        nextTick(() => {
          state.exhPageList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.exhPageTable.toggleRowSelection(item, true)
            } else {
              state.exhPageTable.toggleRowSelection(item, false)
            }
          })
        })
      }

      if (type == 'miniPath') {
        state.activeName = 'miniPath'
        nextTick(() => {
          state.miniPathList.forEach((item) => {
            if (state.echoList.includes(item.id)) {
              state.miniPathTable.toggleRowSelection(item, true)
            } else {
              state.miniPathTable.toggleRowSelection(item, false)
            }
          })
        })
      }
      if (type == 'link') {
        const externalLink = val.find((item) => item.type == 'link')
        state.activeName = 'link'
        state.urlLink = externalLink?.url || ''
      }
      if (type == 'mini') {
        state.activeName = 'mini'
        state.miniData = val[0]?.miniData ? val[0]?.miniData : {}
      }

      if (type == 'wxVideo') {
        state.activeName = 'wxVideo'
        state.wxVideoType = val[0]?.wxVideoType ? val[0]?.wxVideoType : {}
      }
      if (type == 'officialAccount') {
        const officialAccountLink = val.find((item) =>
          ['officialAccount', 'officialAccountProfile'].includes(item.type)
        )
        state.activeName = 'officialAccount'
        if (officialAccountLink) setOfficialAccountEcho(officialAccountLink)
      }
      if (type == 'notopen') {
        state.activeName = 'notopen'
        state.notOpenMes = val[0].extraParams?.notOpenMes
        state.notOpenFlag = val[0].extraParams?.notOpenFlag
      }
    }

    const getShopData = async () => {
      state.listLoading = true
      const { data } = await getShopList(state.queryForm)
      state.list = handleType(data.list, 'shop')
      state.total = data.total
      state.listLoading = false
      if (state.echoList.length > 0) {
        state.list.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.id)) {
            state.shopTable.toggleRowSelection(item, true)
          }
        })
      }
    }

    // 店铺选择
    const handleSelectionChangeByShop = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push(row)
        }

        state.list.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.shopTable.toggleRowSelection(item, true)
          } else {
            state.shopTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'shop')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    //  确定选择
    const confirmChoose = () => {
      let closeFlag = true

      if (state.activeName == 'notopen') {
        state.chooseVal = [
          {
            type: 'notopen',
            extraParams: {
              notOpenFlag: state.notOpenFlag,
              notOpenMes: state.notOpenMes,
            },
          },
        ]
      }
      // 如果 类型是url，增加判断
      if (state.activeName == 'link') {
        state.chooseVal = [
          {
            type: 'link',
            url: state.urlLink,
            extraParams: {
              needToken: state.needToken,
            },
          },
        ]
      }
      if (state.activeName == 'mini') {
        state.chooseVal = [{ type: 'mini', miniData: state.miniData }]
      }
      // 视频号类型
      if (state.activeName == 'wxVideo') {
        state.chooseVal = [{ type: 'wxVideo', wxVideoType: state.wxVideoType }]
      }

      if (state.activeName == 'officialAccount') {
        const { targetType, articleUrl, originId } = state.officialAccountData
        const url = (targetType == 'profile' ? originId : articleUrl).trim()
        if (!url) {
          const message = targetType == 'profile' ? '请输入公众号原始ID' : '请输入公众号文章链接'
          proxy.$baseMessage(message, 'warning', 'vab-hey-message-warning')
          return
        }
        state.chooseVal = [
          {
            type: targetType == 'profile' ? 'officialAccountProfile' : 'officialAccount',
            url,
          },
        ]
      }

      if (state.activeName == 'enterprise') {
        state.chooseVal.forEach((v) => {
          console.log(v, '1231231231vvvv')
          v['code'] = v.enterpriseCode
        })
      }

      if (state.activeName == 'miniPath') {
        state.chooseVal.forEach((v) => {
          if (!v.extraParams) v.extraParams = {}
          if (v.router == 'subPackage/exhibition/customer-exhibition/apply-form') {
            v.extraParams.identity = state.checkIdentity
            if (state.checkIdentity) {
              v.extraParams.identityName = state.identityList.filter(
                (v) => v.identityType == state.checkIdentity
              )[0].name
            }
          }

          if (v.id == 13) {
            v.extraParams.groupId = state.exhibitionListRouter
            if (state.exhibitionListRouter) {
              v.extraParams.groupName = state.exhibitionListRouterList.filter(
                (v) => v.id == state.exhibitionListRouter
              )[0].name
            }
          }

          if (v.id == 36) {
            const groupId = state.recruitmentBrandGroupId
            if (groupId) {
              v.extraParams.groupId = groupId
              v.extraParams.groupName = state.recruitmentGroupListMap[groupId]
            } else {
              closeFlag = false
              proxy.$baseMessage(`请为招聘机构列表选择组`, 'warning', 'vab-hey-message-warning')
            }
          }

          if (v.id == 37) {
            const groupId = state.recruitmentJobGroupId
            if (groupId) {
              v.extraParams.groupId = groupId
              v.extraParams.groupName = state.recruitmentGroupListMap[groupId]
            } else {
              closeFlag = false
              proxy.$baseMessage(`请为岗位列表选择组`, 'warning', 'vab-hey-message-warning')
            }
          }
        })
      }

      if (!closeFlag) return
      state.show = false

      console.log(state.chooseVal, state.activeName, '123123123')
      state.queryMiniPath.type = ''
      emit('chooseLink', state.chooseVal)
      resetRowSelection()
      resetDialogState()
    }

    const handleSizeChangeShop = (val) => {
      state.queryForm.pageSize = val
      getShopData()
    }
    const handleCurrentChangeShop = (val) => {
      state.queryForm.pageNumber = val
      getShopData()
    }

    const queryShopData = () => {
      getShopData()
    }

    const handleDate = (val) => {
      return parseTime(val)
    }

    // 增加数据格式类型
    const handleType = (val, type1) => {
      console.log(type1)
      let nArr = JSON.parse(JSON.stringify(val))
      for (let i in nArr) {
        nArr[i]['type'] = type1
      }
      console.log(nArr)
      return nArr
    }

    /**
     * 活动相关接口
     * */
    // 获取活动列表
    const getActiveData = async () => {
      state.listLoading1 = true
      const { data } = await activeList(state.queryForm1)
      state.activeList = handleType(data.data, 'active')
      state.total1 = data.total
      state.listLoading1 = false
      if (state.echoList.length > 0) {
        state.activeList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.id)) {
            state.acitveTable.toggleRowSelection(item, true)
          }
        })
      }
    }

    const handleSizeChangeActive = (val) => {
      state.queryForm1.pageSize = val
      getActiveData()
    }
    const handleCurrentChangeActive = (val) => {
      state.queryForm1.pageNum = val
      getActiveData()
    }

    const queryActiveData = () => {
      getActiveData()
    }

    const exhibitionData = async () => {
      state.listLoading4 = true
      const { data } = await exShelfAndUnshelfList(state.queryForm4)
      state.exhList = handleType(data.data, 'exhibition')
      state.total1 = data.total
      state.listLoading4 = false
      if (state.echoList.length > 0) {
        state.exhList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.code)) {
            state.exhTable.toggleRowSelection(item, true)
          }
        })
      }
    }
    // 展会内容选中table
    const handleSelectionChangeByExhibition = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.code) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.code)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.code)
          state.chooseVal.push(row)
        }
        state.exhList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.exhTable.toggleRowSelection(item, true)
          } else {
            state.exhTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.code)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.code)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'exhibition')
          state.echoList.forEach((id, index) => {
            if (id === row.code) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    // table 选中 活动
    const handleSelectionChangeByActive = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push(row)
        }
        state.activeList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.acitveTable.toggleRowSelection(item, true)
          } else {
            state.acitveTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'active')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    const getRowKeys = (row) => {
      return row.id
    }

    // 页面模版相关接口
    // 获取页面列表
    const getPageData = async () => {
      state.listLoading2 = true
      const { data } = await getPage(state.queryForm2)
      state.pageList = handleType(data.list, 'page')
      state.total3 = data.total
      state.listLoading2 = false
      console.log(state.echoList)
      if (state.echoList.length > 0) {
        state.pageList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.id)) {
            console.log(item.id)
            state.pageTable.toggleRowSelection(item, true)
          }
        })
      }
    }
    /**
     * @description: 页面模版分页接口
     * @param {*} val
     * @return {*}
     */
    const handleCurrentChangePage = (val) => {
      state.queryForm2.pageNumber = val
      getPageData()
    }
    const handleSizeChangePage = (val) => {
      state.queryForm2.pageSize = val
      getPageData()
    }
    const queryPlatePageData = () => {
      getPageData()
    }

    // 页面配置
    const handleSelectionChangeByPage = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push(row)
        }
        state.pageList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.pageTable.toggleRowSelection(item, true)
          } else {
            state.pageTable.toggleRowSelection(item, false)
          }
        })
      } else {
        console.log(state.echoList.includes(row.id), 'asdasdasdasd')
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'page')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    /**
     * @description:展会页面配置
     * @return {*}
     */
    const getexhPageData = async () => {
      state.listLoadingExhPage = true
      const { data } = await getPage(state.queryFormExhPage)
      state.exhPageList = handleType(data.list, 'exhPage')
      state.exhPageTotal = data.total
      state.listLoadingExhPage = false
      if (state.echoList.length > 0) {
        state.exhPageList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.id)) {
            console.log(item.id)
            state.exhPageTable.toggleRowSelection(item, true)
          }
        })
      }
    }
    /**
     * @description: 页面模版分页接口
     * @param {*} val
     * @return {*}
     */
    const handleCurrentChangeExhPage = (val) => {
      state.queryFormExhPage.pageNumber = val
      getexhPageData()
    }
    const handleSizeChangeExhPage = (val) => {
      state.queryFormExhPage.pageSize = val
      getexhPageData()
    }
    const queryExhPageData = () => {
      getexhPageData()
    }

    // 页面配置
    const handleSelectionChangeByExhPage = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push(row)
        }
        state.exhPageList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.exhPageTable.toggleRowSelection(item, true)
          } else {
            state.exhPageTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'exhPage')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    // 小程序页面路径配置
    const handleSelectionChangeByMiniPath = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push({ ...row })
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push({ ...row })
        }
        state.miniPathData.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.miniPathTable.toggleRowSelection(item, true)
          } else {
            state.miniPathTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push({ ...row })
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'miniPath')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    // 文章相关接口
    // 获取文章列表
    const getArticleData = async () => {
      state.listLoading3 = true
      if (props.enterPriseCode) {
        state.queryForm3.enterpriseCode = props.enterPriseCode
      }
      const { data } = await getArticleList(state.queryForm3)
      state.articleList = handleType(data.data, 'Article')
      state.listLoading3 = false
      state.total2 = data.total
      if (state.echoList.length > 0) {
        state.articleList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          console.log(state.echoList.includes(item.id), 'bvvvasdasdas123123')
          if (state.echoList.includes(item.id)) {
            nextTick(() => {
              state.articleTable.toggleRowSelection(item, true)
            })
          }
        })
      }
    }

    const handleSelectionChangeByArticle = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.id)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.id)
          state.chooseVal.push(row)
        }
        console.log(state.chooseVal, val)
        state.articleList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.articleTable.toggleRowSelection(item, true)
          } else {
            state.articleTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.id)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.id)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'Article')
          state.echoList.forEach((id, index) => {
            if (id === row.id) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    const handleCurrentChangeArticle = (val) => {
      state.queryForm3.pageNum = val
      getArticleData()
    }
    const handleSizeChangeArticle = (val) => {
      state.queryForm3.pageSize = val
      getArticleData()
    }

    const queryArticleData = () => {
      state.queryForm3.pageNum = 1
      getArticleData()
    }

    // 处理当前删除数据
    const handleAlreadyData = (row, type) => {
      state.alreadyChoose.forEach((item, index) => {
        if (item.type == type && item.id == row.id) {
          state.alreadyChoose.splice(index, 1)
        }
      })
    }

    /**
     * @description: 获取所有办个会
     * @return {*}
     */
    const getAllMeet = async () => {
      state.listLoading4 = true
      const { data } = await getPlateAllData(state.queryFormByHoldMeet)
      state.holdMeetList = handleType(data, 'holdMeet')
      state.listLoading4 = false
      if (state.echoList.length > 0) {
        state.holdMeetList.forEach((item) => {
          // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (state.echoList.includes(item.id)) {
            state.holdMeetTable.toggleRowSelection(item, true)
          }
        })
      }
    }

    /**
     * @description: 查询办个会
     * @return {*}
     */
    const queryHoldMeet = () => {
      getAllMeet()
    }
    /**
     * @description: table 选中切换
     * @param {*} val
     * @param {*} row
     * @return {*}
     */
    const handleSelectionChangeByHoldMeet = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.code) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.code)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.code)
          state.chooseVal.push(row)
        }
        state.holdMeetList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.holdMeetTable.toggleRowSelection(item, true)
          } else {
            state.holdMeetTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.code)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.code)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'holdMeet')
          state.echoList.forEach((id, index) => {
            if (id === row.code) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    /**
     * @description: 外部tab切换
     * @return {*}
     */
    const handleBigTabClick = (e) => {
      const map = {
        content: 'miniPath',
        plantForm: 'enterprise',
        thirdLink: 'link',
        notopen: 'notopen',
      }
      if (e.props.name in map) state.activeName = map[e.props.name]
    }

    // 其他H5 链接配置内容

    /**
     * @description: 获取所有办个会
     * @return {*}
     */
    const getEnterprise = async () => {
      state.listLoading6 = true
      const { data } = await getAllEnterpriseListByName(state.queryFormByEnterprise)
      state.enterpriseList = handleType(data, 'enterprise')
      state.listLoading6 = false
    }

    /**
     * @description: 查询办个会
     * @return {*}
     */
    const queryEnterprise = () => {
      getEnterprise()
    }

    /**
     * @description: table 选中切换
     * @param {*} val
     * @param {*} row
     * @return {*}
     */
    const handleSelectionChangeByEnterprise = (val, row) => {
      if (!props.multChoose) {
        if (state.echoList.length > 0) {
          state.echoList.forEach((id, index) => {
            if (id === row.data) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            } else {
              state.echoList = []
              state.chooseVal = []
              state.echoList.push(row.data)
              state.chooseVal.push(row)
            }
          })
        } else {
          state.echoList = []
          state.chooseVal = []
          state.echoList.push(row.data)
          state.chooseVal.push(row)
        }
        state.enterpriseList.forEach((item) => {
          if (val[val.length - 1] === item) {
            state.enterpriseTable.toggleRowSelection(item, true)
          } else {
            state.enterpriseTable.toggleRowSelection(item, false)
          }
        })
      } else {
        if (!state.echoList.includes(row.data)) {
          // 回显数据里没有本条，把这条加进来(选中)
          state.echoList.push(row.data)
          state.chooseVal.push(row)
          state.alreadyChoose.push(row)
        } else {
          // 回显数据里有本条，把这条删除(取消选中)
          handleAlreadyData(row, 'enterprise')
          state.echoList.forEach((id, index) => {
            if (id === row.data) {
              state.echoList.splice(index, 1)
              state.chooseVal.splice(index, 1)
            }
          })
        }
      }
    }

    // onActivated(() => {
    getShopData()
    getActiveData()
    getPageData()
    getArticleData()
    exhibitionData()
    getAllMeet()
    getexhPageData()
    // })

    const selectMinipath = () => {
      if (state.queryMiniPath.type == '') {
        state.miniPathData = state.miniPathList
        return false
      }
      let data = state.miniPathList.filter((v) => v.pathType == state.queryMiniPath.type)
      console.log(data)
      state.miniPathData = data
    }

    return {
      ...toRefs(state),
      selectMinipath,
      handleCurrentChangeArticle,
      handleSizeChangeArticle,
      queryArticleData,
      handleSelectionChangeByShop,
      handleSizeChangeShop,
      handleCurrentChangeShop,
      confirmChoose,
      showDialog,
      Search,
      queryShopData,
      handleDate,
      handleSizeChangeActive,
      handleCurrentChangeActive,
      queryActiveData,
      handleSelectionChangeByActive,
      getRowKeys,
      handleTabClick,
      closeDialog,
      handleSelectionChangeByPage,
      handleSelectionChangeByArticle,
      handleSelectionChangeByMiniPath,
      tabChangeChoose,
      handleSelectionChangeByExhibition,
      handleSelectionChangeByHoldMeet,
      exhibitionData,
      queryHoldMeet,
      handleBigTabClick,
      handleCurrentChangePage,
      handleSizeChangePage,
      queryPlatePageData,
      queryExhPageData,
      handleCurrentChangeExhPage,
      handleSizeChangeExhPage,
      handleSelectionChangeByExhPage,
      queryEnterprise,
      handleSelectionChangeByEnterprise,
    }
  },
})
</script>
<style lang="scss">
.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}

.el-table__fixed-header-wrapper .el-checkbox {
  display: none;
}
</style>
